const updates = [
  { time: '14:32', label: '最新爆料', title: '某顶流男星疑似恋情曝光，工作室火速回应引热议', hot: true },
  { time: '13:15', label: '实时追踪', title: '热门综艺录制现场突发状况，节目组紧急调整流程', hot: true },
  { time: '11:48', label: '独家消息', title: '知名导演新片选角内幕流出，多位一线演员争角', hot: false },
  { time: '10:20', label: '热门事件', title: '网红直播间口误引发全网讨论，当事人深夜发长文道歉', hot: true },
  { time: '09:05', label: '最新爆料', title: '某品牌代言人更换背后：合约纠纷细节首次披露', hot: false },
  { time: '08:30', label: '每日吃瓜', title: '今日吃瓜速递：三大平台同期上新，内容大战一触即发', hot: false },
  { time: '07:22', label: '独家消息', title: '圈内人士爆料某综艺剪辑内幕，真实关系与荧幕形象大不同', hot: false },
  { time: '06:15', label: '最新爆料', title: '昨夜某颁奖礼后台花絮流出，明星互动细节超有料', hot: true },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            最新动态
          </h2>
          <span className="flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
            LIVE
          </span>
        </div>

        <div className="space-y-0">
          {updates.map((item, i) => (
            <div
              key={i}
              className={`flex items-start gap-4 py-3.5 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-background-100/50 px-2 -mx-2 rounded-lg transition-colors ${
                item.hot ? 'relative' : ''
              }`}
            >
              <span className="text-xs font-mono text-foreground-400 whitespace-nowrap pt-0.5 min-w-[40px]">{item.time}</span>
              <span className={`text-xs font-semibold whitespace-nowrap px-2 py-0.5 rounded-full min-w-[72px] text-center ${
                item.label === '独家消息'
                  ? 'bg-accent-100 text-accent-700'
                  : item.label === '最新爆料'
                  ? 'bg-primary-100 text-primary-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}>
                {item.label}
              </span>
              <span className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors leading-snug flex-1">
                {item.title}
                {item.hot && (
                  <span className="inline-flex items-center gap-0.5 ml-2 text-xs text-primary-500 font-semibold align-middle">
                    <i className="ri-fire-line text-[10px]"></i>热
                  </span>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}